import { Fab, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import IconLibrary from '../IconLibrary';

/*
 * position  = { left, top, bottom, right } all boolean OR null
 */

const style = buttonPosition =>
  buttonPosition
    ? {
        position: 'fixed',
        zIndex: 2,
        ...(buttonPosition.left && { left: '50px' }),
        ...(buttonPosition.top && { top: '50px' }),
        ...(buttonPosition.right && { right: '50px' }),
        ...(buttonPosition.bottom && { bottom: '50px' }),
      }
    : {};

function SJFloatingButtons({
  buttonsSchema,
  position = null,
  formRef,
  preSubmitActions = null,
}) {
  window.document.body.style['margin-bottom'] = '120px';
  return (
    <Stack style={style(position)} direction="row" spacing={2}>
      {buttonsSchema.map(buttonSchema => {
        const Icon = IconLibrary[buttonSchema.icon];
        return (
          <Fab
            key={buttonSchema?.label?.id}
            variant="extended"
            size="medium"
            color="primary"
            onClick={() => {
              if (preSubmitActions) {
                preSubmitActions();
              }
              formRef.current.submit(buttonSchema);
            }}>
            <Icon sx={{ mr: 0.6, fontSize: '18px' }} />
            <FormattedMessage
              id={buttonSchema.label.id}
              defaultMessage={buttonSchema.label.defaultMessage}
            />
          </Fab>
        );
      })}
    </Stack>
  );
}

export default SJFloatingButtons;
